var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card"},[_c('div',{staticClass:"card-image"},[_c('figure',{staticClass:"image is-3by1"},[_c('img',{attrs:{"src":_vm.ASSETS_URL + '/banners/spooky.jpeg'}})])]),_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card-content"},[_c('p',{staticClass:"title has-text-centered"},[_vm._v("This page is not available")])])
}]

export { render, staticRenderFns }